// @mui
import { Container, Grid } from '@mui/material';
import { IConfig } from '../../@types/config';
import Markdown from 'components/markdown/Markdown';
import { useSettingsContext } from 'components/settings';
import DashboardLayout from 'layouts/dashboard';
import { ConfigKey } from 'utils/constant';
Collaborators.getLayout = (page: React.ReactElement) => <DashboardLayout>{page}</DashboardLayout>;

export default function Collaborators({ dataConfigs }: { dataConfigs: IConfig[] }) {
  const { themeStretch } = useSettingsContext();
  const congtacvien = dataConfigs.find((f) => f.name === ConfigKey.CongTacVien);
  return (
    <Container maxWidth={themeStretch ? false : 'lg'}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={12}>
          <Markdown children={congtacvien?.value ?? ''} />
        </Grid>
      </Grid>
    </Container>
  );
}
